var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgVersionToggle = function SvgVersionToggle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.688 11.25A3.913 3.913 0 0 1 1 9c0-2.188 1.781-4 4-4h5v2c0 .938 1.125 1.375 1.719.688l2.25-2.5a1.004 1.004 0 0 0 0-1.344l-2.25-2.5C11.125.656 10 1.094 10 2.03V4H5C2.219 4 0 6.25 0 9a5.04 5.04 0 0 0 .875 2.875c.156.188.438.219.594.031l.156-.187a.379.379 0 0 0 .063-.469ZM11 2l2.25 2.5L11 7V2Zm4.094 4.156c-.156-.187-.438-.218-.594-.031l-.156.188a.379.379 0 0 0-.063.468C14.72 7.406 15 8.188 15 9c0 2.219-1.813 4-4 4H6v-1.969c0-.937-1.156-1.375-1.75-.687L2 12.844a1.004 1.004 0 0 0 0 1.344l2.25 2.5c.594.687 1.75.25 1.75-.688v-2h5c2.75 0 5-2.219 5-5a5.043 5.043 0 0 0-.906-2.844ZM5 16l-2.25-2.5L5 11v5Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgVersionToggle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "87bb4a0a942a6a6ede62b16e9b7fe521.svg";